import { i18n } from "services/i18nService";
import { OTHER_CANCELLATION_REASON_OPTION } from "services/sosInventoryService/company/accountInfo/schema";

import { initialErrorState } from "views/common";

export function cancellationIsValid(data) {
  const { reason, additionalComments } = data;
  const errors = initialErrorState();

  if (!reason) {
    errors.messages.push(i18n("isValid.CancellationReason"));
    errors.entity.push("reason");
  }

  if (
    reason &&
    reason.id === OTHER_CANCELLATION_REASON_OPTION.id &&
    (!additionalComments || !additionalComments.trim().length)
  ) {
    errors.messages.push(i18n("isValid.AdditionalComments"));
    errors.entity.push("additionalComments");
  }
  return errors;
}
